import { WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BankAccountMembershipSelector } from 'modules/banking/components/BankAccountMembershipSelector'
import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export const MembershipsStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const handleSelectEmployees = (selection: EmployeeSelectorV2MultiSelectState) => {
    onDataChanged({ ...data, employeeSelection: selection })
  }
  // As there is another step using this.. we have to override the onNext callback
  useOnNext(() => Promise.resolve())

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_3.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_3.subtitle')}
    >
      <BankAccountMembershipSelector onChange={handleSelectEmployees} />
    </WizardStepLayout>
  )
}
